var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-block-activate-premium"},[_c('div',{staticClass:"text-12px fw-300 pb-2"},[_vm._v(_vm._s(_vm.$t('Try Premium 14 days for free')))]),_c('v-btn',{staticClass:"outlined-button w-100",on:{"click":_vm.showPremiumFeaturesModal}},[_vm._v(_vm._s(_vm.$t('Activate premium')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }